import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "../../../../../shared/const/localstorage";
import {GroupsListingResponse} from "../../../types/create-test/group-listing/groupsListingSchema";
import {setGroupsListing} from "../../../slice/create-test/group-listing/groupListingSlice";


export const groupListing = createAsyncThunk(
    "createTest/fetchGroups",
    async (_, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);
            const response = await axios.get<GroupsListingResponse>("/api/tests/groups-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (!response.data) {
                throw new Error("Response data is empty");
            }

            thunkAPI.dispatch(setGroupsListing(response.data.data))
            return response.data;
        } catch (error) {
            // @ts-ignore
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);